module.exports = __webpack_public_path__ + "static/media/tes.7e72aed2.svg";